<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesMstUserLocationResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName" withCustomRowActions
                                      ref="emTable" exportDisabled :inlineActionsDisabled="prop_inline!=='1'"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                              <template #customRowActions="{row}">
                                <b-button-group>
                                  <em-button type="gotoGrandParent" customLabel="工厂模型" show-name
                                             v-bind:class="'btn btn-outline-primary btn-sm'"
                                             @click="gotoGrandParentLevel(row)">
                                  </em-button>
                                </b-button-group>
                              </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
    </div>
</template>
<script>
    // Author YuJiaBei
    // Date 2020-10-02 09:54:22

    import emCommonListMixin from "@/mixin/em/common/list";
    import emCommonGotoMixin from "@/mixin/em/common/goto";

    export default {
        name: "sithMesMstUserLocationListView",
        mixins: [emCommonListMixin,emCommonGotoMixin],
        props:{
            //是否启用行编辑
            prop_inline: {
                type: String,
                default: "0"
            }
        },
        computed:{
            modelName(){
                return this.$_emRouterHelperMixin_entityName
            }
        },
      methods: {
        gotoGrandParentLevel(row) {
          this.$_emGotoMixin_gotoList("sithMesMstLocation", row.mstLocationId ? row.mstLocationId : "")
        }
      }
    };
</script>